<div class="confirm-clear-rule evir-font-default">
  <div mat-dialog-content>
    <p>{{ data.message }}</p>
  </div>
  <div mat-dialog-actions align="center">
    <ng-container *ngIf="!data.noRulesToClear; else noRules">
      <app-action-button cdkFocusInitial title="cancel" (buttonClicked)="dialogRef.close()"></app-action-button>

      <app-action-button title="ok" (buttonClicked)="confirmClearRule()"></app-action-button>

    </ng-container>
    <ng-template #noRules>

      <app-action-button title="ok" (buttonClicked)="dialogRef.close()"></app-action-button>

    </ng-template>

  </div>

</div>
